<fgb-account-layout titleKey="payment.page.title" titleDefault="Payment">
  <fgb-account-panel titleKey="payment.page.title" titleDefault="Payment">
    <div class="bg-primary d-lg-none d-block">
      <fgb-barcode></fgb-barcode>
    </div>

    <fgb-payment-navbar></fgb-payment-navbar>

    <div class="d-none d-lg-block">
      <fgbcl-ecash-description></fgbcl-ecash-description>
      <fgbcl-card-token-list
        [regex]="regex"
        [provider]="provider"
        [showExpiry]="true"
        [redirectUrl]="'/cardtoken/result'"
        [failureUrl]="'/cardtoken/failure'"
        [cardIssuerProvider]="'chase'"
        [version]="2"
      ></fgbcl-card-token-list>
    </div>

    <div class="d-block d-lg-none">
      <fgbcl-card-token-list
        [regex]="regex"
        [provider]="provider"
        [showExpiry]="true"
        [redirectUrl]="'/cardtoken/result'"
        [failureUrl]="'/cardtoken/failure'"
        [cardIssuerProvider]="'chase'"
        [version]="2"
      ></fgbcl-card-token-list>
    </div>

    <div class="mt-4">
      <!-- Express Checkout -->
      <fgbcl-express-checkout-providers
        [providers]="providers"
        [failureUrl]="'/cardtoken/failure'"
        (result)="onExpressCheckoutResult($event)"
        (incomplete)="onExpressCheckoutIncomplete($event)"
      />
    </div>

    <div class="d-block d-lg-none">
      <hr class="horizontal-line w-100 mt-4" />
      <fgbcl-ecash-description></fgbcl-ecash-description>
    </div>

    <div class="d-none d-lg-block mt-4">
      <hr class="horizontal-line mb-4" />
      <fgb-transaction-history
        [transactionTypes]="[transactionTypes.ecash, transactionTypes.payment]"
        [ecashView]="true"
      ></fgb-transaction-history>
    </div>
  </fgb-account-panel>
</fgb-account-layout>
